// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"859d7a4b","34":"c794fbcb","85":"80c74b5f","142":"c5617b41","548":"9d3b3374","632":"f0f58840","669":"c48fe02a","734":"0906ffc5","744":"8b9332b3","823":"f54a8d24","836":"b9cf5b97","868":"fc48033c","981":"cb5a6ac2"}[chunkId] + ".chunk.js";
};